import { Grid, Stack, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import StatusCard from "../../../components/Dashboard/StatusCard";
import CustomRangePicker from "../../../components/DateRangePicker";
import ExportButton from "../../../components/ExportButton";
import Loader from "../../../components/Loader";
import BranchMenu from "../../../components/MenuDropDown/BranchMenu";
import SnackbarAlert from "../../../components/SnackBar";
import appcolors from "../../../constants/Colors";
import { fetchAllBranchaesbyId } from "../../../services/Branches";
import { fetchBusinessReport } from "../../../services/Reporting";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import AllSubscriber from "./AllSubscriber";
import ReportChart from "./ReportChart";
import ReportPiewChart from "./ReportPiewChart";

function ClientReport() {
  const currentYear = moment().year();
  const [isLoading, setIsLoading] = useState(false);
  const [endDate, setEndDate] = useState(moment(`${currentYear}-12-31`));
  const [startDate, setStartDate] = useState(moment(`${currentYear}-01-01`));
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [reports, setReports] = useState(null);
  console.log("reports", reports);

  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [branchesByBusiness, setBranchesByBusiness] = useState([]);
  const { user } = useSelector((state) => state.user);

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });


  const cardData = [
    {
      primary: "Total Appointments",
      secondary: "Appointments",
      value: (reports?.walkInAppointment || 0) + (reports?.onlineAppointment || 0),
      walkIn: reports?.walkInAppointment || 0,
      online: reports?.onlineAppointment || 0,
    },
    {
      primary: "Total Services",
      secondary: "All Services",
      value: reports?.totalServices,
    },
    {
      primary: "Completed Appointments",
      secondary: "Complete sale",
      value: reports?.totalCompletedAppointments,
    },
    {
      primary: "Total Team Member",
      secondary: "All Members",
      value: reports?.totalTeamMember,
    },
  ];


  // const cardData = [
  //   {
  //     primary: "Total Appointments",
  //     secondary: `Walk-In: ${reports?.walkInAppointment || 0}`,
  //     value: reports?.walkInAppointments,
  //     onlineValue: `Online: ${reports?.onlineAppointment || 0}`,
  //   },
  //   {
  //     primary: "Total Services",
  //     secondary: "All Services",
  //     value: reports?.totalServices,
  //     onlineValue: "",
  //   },
  //   {
  //     primary: "Completed Appointments",
  //     secondary: "Complete sale",
  //     value: reports?.totalCompletedAppointments,
  //     onlineValue: "",
  //   },
  //   {
  //     primary: "Total Team Member",
  //     secondary: "All Members",
  //     value: reports?.totalTeamMember,
  //     onlineValue: "",
  //   },
  // ];

  useEffect(() => {
    if (selectedBranch) handleFetchBusinessReport();
  }, [selectedBranch]);

  const handleFetchBusinessReport = async () => {
    try {
      let params = {
        branchId: selectedBranch,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      };

      setIsLoading(true);
      const response = await fetchBusinessReport(params);
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        let data = response.data?.data;
        setReports(data);
      } else {
        handleSnackbarVal(true, "error", response?.data?.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerrorerror");
    }
  };

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleDatesChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <NavigationDrawer>
      <AppContainer
        primaryHeading={"Reporting and anaslytics"}
        secondaryHeading={"Access all of your LOBA reports."}
        handleSearch={handleFetchBusinessReport}
        showSerachButton
        showDateRange={
          <CustomRangePicker
            stackProps={{
              boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
              borderRadius: "6px",
            }}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            handleDatesChange={handleDatesChange}
          />
        }
      >
        <Loader isLoading={isLoading} />
        <SnackbarAlert
          handleCloseSnackbar={handleCloseSnackbar}
          snackbarProps={snackbarProps}
        />
        <Grid container mt={3} spacing={2}>
          {cardData?.map((val, _ind) => {
            return <StatusCard val={val} />;
          })}
        </Grid>
        <ReportChart data={reports?.mainChart} />
        <Grid container mt={3} spacing={2}>
          <Grid item xs={12} md={8}>
            {reports?.serviceSales?.length > 0 ? (
              <AllSubscriber data={reports?.serviceSales} />
            ) : (
              <Stack
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                }}
              >
                <Typography
                  variant="body2"
                  fontSize={"1rem"}
                  color={appcolors.crayolaGrey}
                >
                  No Data found!
                </Typography>
              </Stack>
            )}
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid
              container
              spacing={1}
              mt={{ xs: 0, md: 3 }}
              justifyContent={"center"}
            >
              {reports?.serviceSales?.length > 0 ? (
                <>
                  {reports?.serviceSales.map((val, _ind) => {
                    return <ReportPiewChart val={val} _ind={_ind} />;
                  })}
                </>
              ) : (
                <Stack
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "400px",
                  }}
                >
                  <Typography
                    variant="body2"
                    fontSize={"1rem"}
                    color={appcolors.crayolaGrey}
                  >
                    No Data found!
                  </Typography>
                </Stack>
              )}
            </Grid>
          </Grid>
        </Grid>
      </AppContainer>
    </NavigationDrawer>
  );
}

export default ClientReport;
